module.exports = __webpack_public_path__ + "img/404-error-illustration-3afe5de163f0b3bea1b97afec3b3171e.svg";